const host = window.location.host

export default {
  // 图片拼接路径
  fileDomain: 'http://file.dg.vanke.geekclo.com/',

  // im
  imAppId: 1400369127,
}